import React, { ReactNode } from 'react';
import './RiskScoreBarChart.css';

type TScore = {
    index: number;
    className?: string;
    children?: ReactNode;
}

type TRiskScoreBarChart = {
    activeIndex?: number;
    scores?: TScore[];
};

const RiskScoreBarChart: React.FC<TRiskScoreBarChart> = ({
    activeIndex = 0,
    scores = [],
}) => (
    <div className="RiskScoreBarChart_container">
        {scores?.map((score) => (
            <div
                key={score?.index}
                className={`RiskScoreBarChart_item ${score?.className}${
                    activeIndex.toString() === score.index.toString() ? ' active' : ''
                }`}
            >
                {score?.children || <></>}
            </div>
        ))}
    </div>
);

export default RiskScoreBarChart;
